import { render, staticRenderFns } from "./ModalDetalhes.vue?vue&type=template&id=7794cb6d&"
import script from "./ModalDetalhes.vue?vue&type=script&lang=js&"
export * from "./ModalDetalhes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports